import { useGridTabsContext } from '@/scopes/prices/components/GridTabsContext'

import { getFiltersSelector } from '@/scopes/prices/components/selectors'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import { tk } from '@sunwebgroup/ui-components'
import { PropsWithChildren, useEffect, useRef } from 'react'
import { css, styled } from 'styled-components'

const GridTabsWrapper = styled.div`
  width: 100%;
  border-bottom: 2px solid ${tk('color_semantic_border')};
  display: flex;
  flex-direction: row;
  overflow-x: auto;
`

export function GridTabs({ children, className }: { className?: string } & PropsWithChildren) {
  const { isEmpty, error } = usePricesSelector(getFiltersSelector)
  const { selectedTab } = useGridTabsContext()
  const tabRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (tabRef.current && selectedTab !== 'alertService') {
      const selectedTabElement = document.getElementById(selectedTab)
      if (selectedTabElement) {
        const parent = tabRef.current
        const parentRect = parent.getBoundingClientRect()
        const childRect = selectedTabElement.getBoundingClientRect()
        const scrollLeft
          = selectedTabElement.offsetLeft
            - parent.offsetLeft
            - (parentRect.width / 2)
            + (childRect.width / 2)
        parent.scrollTo({ left: scrollLeft, behavior: 'smooth' })
      }
    }
  }, [selectedTab])
  if (isEmpty || error)
    return null

  return <GridTabsWrapper ref={tabRef} className={className}>{children}</GridTabsWrapper>
}

export const GridTab = styled.div<{ $selected: boolean }>`
  height: ${tk('spacing_3xl')};
  padding: ${tk('spacing_md')} ${tk('spacing_lg')};
  text-align: center;
  cursor: pointer;
  white-space: nowrap;

  ${({ $selected }) =>
    $selected
    && css`
      border-bottom: 2px solid ${tk('color_semantic_text_subdued_hover')};
    `}
  &:hover {
    border-bottom: 2px solid ${tk('color_semantic_text_subdued_hover')};
  }
`
